import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollTo } from "../lib/smoothScroll";
import { TEST_IDS } from "../constants/testIds";
import { Link, useLocation } from "react-router-dom";

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => (e) => {
    e.preventDefault();
    if (!isHome) {
      window.location.href = `/#${id}`;
      return;
    }
    scrollTo(`#${id}`);
  };

  return (
    <>
      <motion.header
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: EASE_IN, delay: 0.2 }}
        className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
          scrolled
            ? "backdrop-blur-xl bg-[#0A0C10]/75 border-b border-white/10"
            : "bg-transparent"
        }`}
      >
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid={TEST_IDS.nav.logo}
            className="flex items-center gap-3 group"
          >
            <div className="relative w-10 h-10 shrink-0">
              <img
                src="https://customer-assets-rejwkqb3.emergentagent.net/job_foxtherm-radianti/artifacts/sgmszqf1_logo_trasp.png"
                alt="Foxtherm"
                className="absolute inset-0 w-full h-full object-contain select-none"
                draggable="false"
              />
            </div>
            <div className="leading-none">
              <div
                className="font-display font-black text-[17px] tracking-[-0.04em] uppercase text-white"
                style={{ fontStretch: "condensed" }}
              >
                Fox<span className="text-[#E31E24]">therm</span>
              </div>
            </div>
          </Link>

          <div className="flex items-center gap-6" />
        </div>
      </motion.header>
    </>
  );
}

const EASE_IN = [0.76, 0, 0.24, 1];
